import React from "react";
import { Field } from "react-final-form";
import { TextField } from "@mui/material";
import RffInputWrapper from "../shared/RffInputWrapper";

const RffTextField = ({
  name,
  label,
  required = false,
  helperText,
  placeholder,
  fullWidth = true,
  row = false,
  suppressGrid,
  size,
  disabled,
  onBlur,
  type = "text",
}) => (
  <RffInputWrapper
    label={label}
    suppressGrid={suppressGrid}
    size={size}
    helperText={helperText}
    required={required}
    row={row}
  >
    <Field
      name={name}
      validate={(v) =>
        required && (v == null || v === "") ? "This field is required" : undefined
      }
      parse={(v) => (v === "" ? undefined : v)}
      render={({ input, meta }) => (
        <TextField
          {...input}
          type={type}
          placeholder={placeholder}
          disabled={disabled}
          fullWidth={fullWidth}
          onBlur={(e) => {
            input.onBlur(e);
            if (onBlur) onBlur(e);
          }}
          error={meta.touched && !!meta.error}
          helperText={meta.touched && meta.error ? meta.error : null}
        />
      )}
    />
  </RffInputWrapper>
);

export default RffTextField;
